import axios from "../axiosConfig";

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const LensTypeMaster = {
  insertLensTypeMaster: async (data) => {
    ;
    try {
      const apiUrl = `${WebApiUrl}/api/LensTypeMaster`;

      //const apiUrl = `${express_server_url}/api/Station`;
      console.log(apiUrl);
      console.log(data);
      const response = await axios.post(
        apiUrl,
        {
          title: data.title,
          ef1: data.ef1,
          description: data.description,
          ef2: data.ef2,
          isActive: Boolean(data.isActive),
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      console.log("Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },
  // ************************* Get All ***************************
  getLensTypeMaster: async () => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensTypeMaster/GetLensTypeMasters`;
      //const apiUrl = `${express_server_url}/api/Station/GetStationMasters`;
      const response = await axios.post(
        apiUrl,
        {
          filter: [
            {
              fieldName: "string",
              operatorName: "string",
              compareValue: "string",
            },
          ],
          order: [
            {
              propertyName: "string",
              ascending: true,
            },
          ],
          pageNumber: 0,
          pageSize: 0,
        },
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // ************************* Get All ***************************
  getLensTypeMasterFilter: async () => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensTypeMaster/GetLensTypeMasters`;
      const response = await axios.post(
        apiUrl,
        {
          filter: [],
          order: [
            {
              propertyName: "id",
              ascending: false,
            },
          ],
          pageNumber: 0,
          pageSize: 500000,
        },
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // ************************* Delete ****************************
  deleteLensTypeMaster: async (lensTypeId) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensTypeMaster?lensTypeId=${lensTypeId}`;

      //const apiUrl = `${express_server_url}/api/Station?stationId=${stationId}`;
      const response = await axios.delete(apiUrl, {
        withCredentials: true,
      });
      console.log("Delete Response:", response.data.result);
      return true;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // ************************* Get By Id ****************************
  getLensTypeMasterById: async (lensTypeId) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensTypeMaster?lensTypeId=${lensTypeId}`;

      //const apiUrl = `${express_server_url}/api/Station?stationId=${stationId}`;
      const response = await axios.get(
        apiUrl,
        {},
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },
  // *************************** Update ***************************

  updateLensTypeMaster: async (data) => {
    ;
    console.log(data.id);
    try {
      const apiUrl = `${WebApiUrl}/api/LensTypeMaster?lensTypeId=${data.id}`;

      //const apiUrl = `${express_server_url}/api/Station?stationId=${data.id}`;
      console.log(apiUrl);
      const response = await axios.put(
        apiUrl,
        {
          id: data.id,
          title: data.title,
          ef1: data.ef1,
          description: data.description,
          ef2: data.ef2,
          isActive: Boolean(data.isActive),
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      console.log("Response:", response.data);
      return response.data.isSuccess;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  // ******************************* Update Lens Package Image ************************
  //  UpdateLensTypeImage: async (imageArray) => {
  //     try {
  //       
  //       console.log(imageArray);

  //       const apiUrl = `${WebApiUrl}/api/LensTypeMaster/UpdateLensTypeImage}`;
  //       const response = await axios.post(apiUrl, imageArray, {
  //         withCredentials: true,
  //         credentials: "include",
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       });
  //       console.log("Response:", response.data.isSuccess);
  //       if (response.data.isSuccess == false) {
  //         console.error("Update failed:", response.data.errorMessages);
  //         alert(response.data.errorMessages);
  //         return false;
  //       }
  //       await new Promise((resolve) => setTimeout(resolve, 1000));
  //       return response.data.result;
  //     } catch (error) {
  //       console.error("Error:", error.message);
  //       throw error;
  //     }
  //   },

  UpdateLensTypeImage: async (imageFile, LensTypeId) => {
    try {
      ;
      if (!imageFile) {
        console.error("No image selected");
        return false;
      }

      const formData = new FormData();
      formData.append("file", imageFile[0]); // Ensure imageFile is a File object

      const apiUrl = `${WebApiUrl}/api/LensTypeMaster/UpdateLensTypeImage?LensTypeId=${LensTypeId}`; // Fixed URL

      const response = await axios.post(apiUrl, formData, {
        withCredentials: true,
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Response:", response.data);
      if (!response.data.isSuccess) {
        console.error("Update failed:", response.data.errorMessages);
        alert(response.data.errorMessages);
        return false;
      }
      return response.data.result;
    } catch (error) {
      console.error("Error uploading image:", error.message);
      throw error;
    }
  },
};

export default LensTypeMaster;
